import {
    GET_AREAS_ERROR,
    GET_AREAS_START,
    GET_AREAS_SUCCESS,
} from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.areas.data, action = {type: ''}) => {
    switch (action.type) {
        case GET_AREAS_START:
            return {
                ...state,
                error: false,
                loading: true,
            };
        case GET_AREAS_SUCCESS:
            return {
                ...state,
                list: action.payload,
                loading: false,
            };
        case GET_AREAS_ERROR:
            return {
                ...state,
                error: true,
                loading: false,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/areaReducer/getAreasReducer.js